import { useMessages } from "src/context/MessagingProvider";
import NewMessageForm from "./components/NewMessageForm";
import Message from "./components/Message";
import Box from "@mui/material/Box";
import { useEffect, useRef } from "react";
import { useMessageThreads } from "src/context/MessageThreadsProvider";
import { useIsMobile } from "src/hooks/useIsMobile";

const Messages = () => {
  const bottomRef = useRef<HTMLDivElement>(null);
  const { messages } = useMessages();
  const { currentThread } = useMessageThreads();
  const isMobile = useIsMobile();

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <>
      <Box
        sx={{ flex: 1, overflowY: "auto", mt: 2, mb: 2, p: isMobile ? 0 : 1 }}
        role="list"
        aria-label="Messages"
      >
        {messages.map((message) => (
          <Message message={message} key={message.public_id} />
        ))}
        <div ref={bottomRef} />
      </Box>
      {currentThread?.is_active ? <NewMessageForm /> : null}
    </>
  );
};

export default Messages;
